import { createSlice } from "@reduxjs/toolkit";

export const surveillanceStopDiscoverySlice = createSlice({
  name: "surveillanceStopDiscovery",
  initialState: {
    resource: "surveillanceDiscovery",
    data: {},
  },
});

export default surveillanceStopDiscoverySlice.reducer;
